
// Declare action names as constants with uppercase string

import ApiService from '../services/ApiService';
export const COURSE_MULTIMEDIA_BEGIN = 'COURSE_MULTIMEDIA_BEGIN';
export const COURSE_MULTIMEDIA_SUCCESS = 'COURSE_MULTIMEDIA_SUCCESS';
export const COURSE_MULTIMEDIA_FAILURE = 'COURSE_MULTIMEDIA_FAILURE';
export const COURSE_MULTIMEDIA_CLEAR = 'COURSE_MULTIMEDIA_CLEAR';

// Thunk: this is a special type of action that can dispatch other actions
export function fetchCourseMultimedia(data) {
    return async dispatch => {
        dispatch(courseMultimediaBegin());
        await ApiService.getCourseMultimedia(data)
            .then(
                result => {
                    dispatch(courseMultimediaSuccess(result));
                },
                error => {
                    dispatch(courseMultimediaFailure(error));
                    // eslint-disable-next-line no-throw-literal
                    throw ({ error: error, message: 'Ops! user authentication failed' });
                }
            )
    };
}

// Action: Function that returns an object with action data for reducer
export const courseMultimediaBegin = () => ({
    type: COURSE_MULTIMEDIA_BEGIN
});
export const courseMultimediaSuccess = data => ({
    type: COURSE_MULTIMEDIA_SUCCESS,
    payload: { data }
});
export const courseMultimediaFailure = error => ({
    type: COURSE_MULTIMEDIA_FAILURE,
    payload: { error }
});

export const clearCourseMultimedia = () => ({
    type: COURSE_MULTIMEDIA_CLEAR
})